"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _rcResizeObserver = _interopRequireDefault(require("rc-resize-observer"));
var _ref = require("rc-util/lib/ref");
var _SizeContext = _interopRequireDefault(require("./SizeContext"));
var _StyledAvatar = _interopRequireWildcard(require("./StyledAvatar"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _Icon = _interopRequireDefault(require("../Icon"));
var _excluded = ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt", "children", "badge"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InternalAvatar = function InternalAvatar(props, ref) {
  var groupSize = React.useContext(_SizeContext.default);
  var _React$useState = React.useState(1),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    scale = _React$useState2[0],
    setScale = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    mounted = _React$useState4[0],
    setMounted = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    isImgExist = _React$useState6[0],
    setIsImgExist = _React$useState6[1];
  var avatarNodeRef = React.useRef();
  var avatarChildrenRef = React.useRef();
  var avatarNodeMergeRef = (0, _ref.composeRef)(ref, avatarNodeRef);
  var setScaleParam = function setScaleParam() {
    if (!avatarChildrenRef.current || !avatarNodeRef.current) {
      return;
    }
    var childrenWidth = avatarChildrenRef.current.offsetWidth;
    var nodeWidth = avatarNodeRef.current.offsetWidth;
    if (childrenWidth !== 0 && nodeWidth !== 0) {
      var _props$gap = props.gap,
        gap = _props$gap === void 0 ? 4 : _props$gap;
      if (gap * 2 < nodeWidth) {
        setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
      }
    }
  };
  React.useEffect(function () {
    setMounted(true);
  }, []);
  React.useEffect(function () {
    setIsImgExist(true);
    setScale(1);
  }, [props.src]);
  React.useEffect(function () {
    setScaleParam();
  }, [props.gap]);
  var handleImgLoadError = function handleImgLoadError() {
    var onError = props.onError;
    var errorFlag = onError ? onError() : undefined;
    if (errorFlag !== false) {
      setIsImgExist(false);
    }
  };
  var prefixCls = props.prefixCls,
    shape = props.shape,
    customSize = props.size,
    src = props.src,
    srcSet = props.srcSet,
    icon = props.icon,
    className = props.className,
    alt = props.alt,
    children = props.children,
    badge = props.badge,
    others = (0, _objectWithoutProperties2.default)(props, _excluded);
  var size = customSize === 'default' ? groupSize : customSize;
  var sizeCls = (0, _classnames3.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-xs"), size === 'xsmall'), "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-xl"), size === 'xlarge'), "".concat(prefixCls, "-xxl"), size === 'xxlarge'));
  var hasImageElement = /*#__PURE__*/React.isValidElement(src);
  var classString = (0, _classnames3.default)(prefixCls, sizeCls, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(shape), !!shape), "".concat(prefixCls, "-image"), hasImageElement || src && isImgExist), "".concat(prefixCls, "-icon"), !!icon), className);
  var sizeStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: props.inGroup ? "".concat(size - 4, "px") : "".concat(size, "px"),
    fontSize: icon ? size / 2 : size * 0.4
  } : {};
  var childrenToRender;
  if (!src && !children && !icon) {
    var iconSize;
    switch (size) {
      case 'xsmall':
        iconSize = 24;
        break;
      case 'small':
        iconSize = 32;
        break;
      case 'default':
        iconSize = 40;
        break;
      case 'large':
        iconSize = 48;
        break;
      case 'xlarge':
        iconSize = 64;
        break;
      case 'xxlarge':
        iconSize = 80;
        break;
      default:
        iconSize = size;
    }
    childrenToRender = /*#__PURE__*/React.createElement(_Icon.default, {
      name: "avatar",
      color: "#c2c2c2",
      size: typeof iconSize === 'number' ? props.inGroup ? iconSize - 4 : iconSize : 40
    });
  } else if (typeof src === 'string' && isImgExist) {
    childrenToRender = /*#__PURE__*/React.createElement("img", {
      src: src,
      srcSet: srcSet,
      onError: handleImgLoadError,
      alt: alt
    });
  } else if (hasImageElement) {
    childrenToRender = src;
  } else if (icon) {
    childrenToRender = icon;
  } else if (mounted || scale !== 1) {
    var transformString = "scale(".concat(scale, ") translateX(-50%)");
    var childrenStyle = {
      msTransform: transformString,
      WebkitTransform: transformString,
      transform: transformString
    };
    var sizeChildrenStyle = typeof size === 'number' ? {
      lineHeight: props.inGroup ? "".concat(size - 4, "px") : "".concat(size, "px")
    } : {};
    childrenToRender = /*#__PURE__*/React.createElement(_rcResizeObserver.default, {
      onResize: setScaleParam
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-string"),
      ref: function ref(node) {
        avatarChildrenRef.current = node;
      },
      style: _objectSpread(_objectSpread({}, sizeChildrenStyle), childrenStyle)
    }, children));
  } else {
    childrenToRender = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-string"),
      style: {
        opacity: 0
      },
      ref: function ref(node) {
        avatarChildrenRef.current = node;
      }
    }, children);
  }
  var badgeNoNumberPosition;
  var badgeNumberPosition;
  if (shape === 'square') {
    badgeNoNumberPosition = -2;
    badgeNumberPosition = -5;
  } else if (size === 'xsmall' || typeof size === 'number' && size <= 25) {
    badgeNoNumberPosition = -1;
    badgeNumberPosition = -6;
  } else if (size === 'small' || typeof size === 'number' && size > 25 && size <= 35) {
    badgeNoNumberPosition = 0;
    badgeNumberPosition = -5;
  } else if (size === 'default' || typeof size === 'number' && size > 35 && size <= 45) {
    badgeNoNumberPosition = 2;
    badgeNumberPosition = -3;
  } else if (size === 'large' || typeof size === 'number' && size > 45 && size <= 55) {
    badgeNoNumberPosition = 3;
    badgeNumberPosition = -2;
  } else if (size === 'xlarge' || typeof size === 'number' && size > 55 && size <= 65) {
    badgeNoNumberPosition = 5;
    badgeNumberPosition = 0;
  } else if (size === 'xxlarge' || typeof size === 'number' && size > 65 && size < 85) {
    badgeNoNumberPosition = 8;
    badgeNumberPosition = 3;
  } else if (typeof size === 'number' && size >= 85 && size <= 150) {
    badgeNoNumberPosition = size / 9;
    badgeNumberPosition = badgeNoNumberPosition - 5;
  } else if (typeof size === 'number' && size > 150) {
    badgeNoNumberPosition = size / 8;
    badgeNumberPosition = badgeNoNumberPosition - 5;
  }
  var badgeToRender = null;
  if (badge && typeof badge === 'boolean') {
    badgeToRender = /*#__PURE__*/React.createElement(_StyledAvatar.StyledBadge, {
      $noNumber: true,
      position: badgeNoNumberPosition
    });
  } else if (typeof badge === 'number' || typeof badge === 'string') {
    badgeToRender = /*#__PURE__*/React.createElement(_StyledAvatar.StyledBadge, {
      position: badgeNumberPosition
    }, badge > 99 ? '99+' : badge);
  }

  // The event is triggered twice from bubbling up the DOM tree.
  // see https://codesandbox.io/s/kind-snow-9lidz
  delete others.onError;
  delete others.gap;
  return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(_StyledAvatar.default, (0, _extends2.default)({}, others, {
      style: _objectSpread(_objectSpread({}, sizeStyle), others.style),
      className: classString,
      ref: avatarNodeMergeRef,
      theme: theme,
      $prefixCls: prefixCls
    }), childrenToRender, badgeToRender);
  });
};
var Avatar = /*#__PURE__*/React.forwardRef(InternalAvatar);
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
  prefixCls: 'ykb-ui-avatar',
  shape: 'circle',
  size: 'default',
  badge: false
};
var _default = exports.default = Avatar;